import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { useState } from 'react';
import Login from "./pages/Login";
import Dash from "./pages/Dash";
import Business from "./pages/Business";
import Support from "./pages/Support";
import NotFound from './pages/NotFound';
import Ticket from './pages/Ticket';
import PrivateRoute from './pages/PrivateRoute';
import Profile from './pages/Profile';
import Leverage from './pages/leverage';
function App() {
  const [ipAddress] = useState("108.108.108.108");
  const [token, setToken] = useState('');
  const handleLogin = (token) => {
    setToken(token);
  };
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/"><Login ipAddress={ipAddress} onLogin={handleLogin} /></Route>
        <PrivateRoute exact path="/dash" component={Dash} />
        <PrivateRoute exact path="/business" component={Business} />
        <PrivateRoute exact path="/buynow" component={Leverage} />

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
